import { render, staticRenderFns } from "./BoletoDesktopB.vue?vue&type=template&id=49c95100"
import script from "./BoletoDesktopB.vue?vue&type=script&lang=js"
export * from "./BoletoDesktopB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports